// extracted by mini-css-extract-plugin
export var chip = "_n8-0";
export var icon = "_n8-1";
export var remove = "_n8-2";
export var removeIcon = "_n8-3";